import { FC } from 'react';

import { GiftSellerSidebar } from '@service/giftSeller/containers/GiftSellerSidebar/GiftSellerSidebar';
import { GiftSellerTopBar } from '@service/giftSeller/containers/GiftSellerTopBar/GiftSellerTopBar';
import { GiftChoiceUnitFormPage } from '@service/giftSeller/page/GiftChoiceUnitFormPage';
import { GiftChoiceUnitListPage } from '@service/giftSeller/page/GiftChoiceUnitListPage';
import { GiftCouponHistorySearchPage } from '@service/giftSeller/page/GiftCouponHistorySearchPage';
import { GiftCouponRedemptionListPage } from '@service/giftSeller/page/GiftCouponRedemptionListPage';
import { GiftCouponThemeFormPage } from '@service/giftSeller/page/GiftCouponThemeFormPage';
import { GiftBrandSellerUserPage } from '@service/giftSeller/page/GiftBrandSellerUserPage';
import { GiftCouponThemeListPage } from '@service/giftSeller/page/GiftCouponThemeListPage';
import { GiftChannelLedgerPage } from '@service/giftSeller/page/GiftChannelLedgerPage';
import { GiftDeliveredHistoryPage } from '@service/giftSeller/page/GiftDeliveredHistoryPage';
import { GiftDeliveryCategoryFormPage } from '@service/giftSeller/page/GiftDeliveryCategoryFormPage';
import { GiftDeliveryCategoryListPage } from '@service/giftSeller/page/GiftDeliveryCategoryListPage';
import { GiftDeliveryManagementPage } from '@service/giftSeller/page/GiftDeliveryManagementPage';
import { GiftEventLogPage } from '@service/giftSeller/page/GiftEventLogPage';
import { GiftItemBrandFormPage } from '@service/giftSeller/page/GiftItemBrandFormPage';
import { GiftItemBrandListPage } from '@service/giftSeller/page/GiftItemBrandListPage';
import { GiftItemFormPage } from '@service/giftSeller/page/GiftItemFormPage';
import { GiftItemInfoFormPage } from '@service/giftSeller/page/GiftItemInfoFormPage';
import { GiftItemInfoListPage } from '@service/giftSeller/page/GiftItemInfoListPage';
import { GiftItemListPage } from '@service/giftSeller/page/GiftItemListPage';
import { GiftOrderAnalysisPage } from '@service/giftSeller/page/GiftOrderAnalysisPage';
import { GiftOrderDashboardPage } from '@service/giftSeller/page/GiftOrderDashboardPage';
import { GiftOrderListPage } from '@service/giftSeller/page/GiftOrderListPage';
import { GiftOrderSearchPage } from '@service/giftSeller/page/GiftOrderSearchPage';
import { GiftSellerSettingsPage } from '@service/giftSeller/page/GiftSellerSettingsPage';
import { GiftSettlementAgencyPage } from '@service/giftSeller/page/GiftSettlementAgencyPage';
import { GiftSettlementSupplyPage } from '@service/giftSeller/page/GiftSettlementSupplyPage';
import { IssuedManagementPage } from '@service/giftSeller/page/IssuedManagementPage';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes } from 'react-router-dom';

const GiftSellerAuthRouter: FC = () => {
  const { isGiftAgent, isAdmin } = useAuth();

  const isSellerAuthenticated = isGiftAgent() || isAdmin();

  if (isSellerAuthenticated) {
    sessionStorage.removeItem('redirectUrlAfterGiftSellerLogin');
    return (
      <>
        <GiftSellerSidebar />
        <div className="min-h-screen lg:pl-64">
          <div className="absolute right-0 top-0">
            <GiftSellerTopBar />
          </div>
          <div className="flex flex-1 flex-col">
            <Routes>
              <Route path="" element={<GiftOrderListPage />} />
              <Route path="home" element={<GiftOrderListPage />} />
              <Route path="dashboard" element={<GiftOrderDashboardPage />} />
              {/* GiftOrder (주문 관리) */}
              <Route path="order-search" element={<GiftOrderSearchPage />} />
              {/* 환불/연장 관리 */}
              <Route path="issued-management" element={<IssuedManagementPage />} />
              {/* GiftCoupon (쿠폰 교환신청) */}
              <Route
                path="coupon-redemption"
                element={<GiftCouponRedemptionListPage />}
              />
              <Route path="coupon-history" element={<GiftCouponHistorySearchPage />} />
              {/* 발송내역 조회 (날짜별 발송완료 + 도매가/매체 수정) */}
              <Route path="delivered-history" element={<GiftDeliveredHistoryPage />} />
              {/* 매체 충전금 미러 원장 (잔액 대사·수동 기장) */}
              <Route path="channel-ledger" element={<GiftChannelLedgerPage />} />
              {/* GiftDelivery (배송 관리) */}
              <Route
                path="delivery-management"
                element={<GiftDeliveryManagementPage />}
              />
              {/* GiftItemBrand (상품 브랜드) */}
              <Route path="item-brand" element={<GiftItemBrandListPage />} />
              <Route path="item-brand/new" element={<GiftItemBrandFormPage />} />
              <Route
                path="item-brand/:brandId/edit"
                element={<GiftItemBrandFormPage />}
              />
              {/* 배송관리자(GiftBrandSeller) 계정 관리 - 관리자 전용 */}
              <Route path="brand-seller-user" element={<GiftBrandSellerUserPage />} />
              {/* GiftDeliveryCategory (배송 카테고리) */}
              <Route
                path="delivery-category"
                element={<GiftDeliveryCategoryListPage />}
              />
              <Route
                path="delivery-category/new"
                element={<GiftDeliveryCategoryFormPage />}
              />
              <Route
                path="delivery-category/:categoryId/edit"
                element={<GiftDeliveryCategoryFormPage />}
              />
              {/* GiftChoiceUnit (선택유닛) */}
              <Route path="choice-unit" element={<GiftChoiceUnitListPage />} />
              <Route path="choice-unit/new" element={<GiftChoiceUnitFormPage />} />
              <Route
                path="choice-unit/:unitId/edit"
                element={<GiftChoiceUnitFormPage />}
              />
              {/* GiftCouponTheme (교환권 테마) */}
              <Route path="coupon-theme" element={<GiftCouponThemeListPage />} />
              <Route path="coupon-theme/new" element={<GiftCouponThemeFormPage />} />
              <Route
                path="coupon-theme/:themeId/edit"
                element={<GiftCouponThemeFormPage />}
              />
              {/* GiftItem (브랜드별 판매상품) */}
              <Route path="item" element={<GiftItemListPage />} />
              <Route path="item/new" element={<GiftItemFormPage />} />
              <Route path="item/:itemId/edit" element={<GiftItemFormPage />} />
              {/* GiftItemInfo (원상품) */}
              <Route path="item-info" element={<GiftItemInfoListPage />} />
              <Route path="item-info/new" element={<GiftItemInfoFormPage />} />
              <Route
                path="item-info/:itemInfoId/edit"
                element={<GiftItemInfoFormPage />}
              />
              {/* GiftEventLog (이벤트 로그) */}
              <Route path="event-log" element={<GiftEventLogPage />} />
              {/* 데이터 분석 */}
              <Route path="analysis" element={<GiftOrderAnalysisPage />} />
              {/* 정산 관리 — 배송업체(supply) / 상조 배송형(rebate) / 상조 쿠폰형(coupon) 페이지 분리 */}
              <Route
                path="settlement"
                element={<Navigate to="/gift-seller/settlement/supply" replace />}
              />
              <Route path="settlement/supply" element={<GiftSettlementSupplyPage />} />
              {/* 상조 정산은 배송형·쿠폰형을 한 페이지(월별 합계 + 종류별 탭)로 통합.
                  기존 종류별 경로는 해당 탭으로 넘긴다(북마크 보존). */}
              <Route path="settlement/agency" element={<GiftSettlementAgencyPage />} />
              <Route
                path="settlement/agency/delivery"
                element={
                  <Navigate to="/gift-seller/settlement/agency?tab=delivery" replace />
                }
              />
              <Route
                path="settlement/agency/coupon"
                element={
                  <Navigate to="/gift-seller/settlement/agency?tab=coupon" replace />
                }
              />
              {/* 계정정보 */}
              <Route path="settings" element={<GiftSellerSettingsPage />} />
              <Route path="*" element={<Navigate to="/gift-seller/home" />} />
            </Routes>
          </div>
        </div>
      </>
    );
  } else {
    return <Navigate to="/gift-seller/login" />;
  }
};

export default GiftSellerAuthRouter;
